import cartIcon from "@/assets/icons/cart.webp";
import heartIcon from "@/assets/icons/heart.webp";
import searchIcon from "@/assets/icons/search.webp";
import searchNewIcon from "@/assets/icons/search-new.webp";
import lockIcon from "@/assets/icons/lock.webp";
import accountIcon from "@/assets/icons/account.webp";
import starIcon from "@/assets/icons/star.webp";
import phoneIcon from "@/assets/icons/phone.webp";
import mailIcon from "@/assets/icons/mail.webp";
import mapPinIcon from "@/assets/icons/map-pin.webp";
import eyeIcon from "@/assets/icons/eye.webp";
import quickViewIcon from "@/assets/icons/quick-view.webp";
import instagramIcon from "@/assets/icons/instagram.webp";
import facebookIcon from "@/assets/icons/facebook.webp";
import tiktokIcon from "@/assets/icons/tiktok.webp";

const iconMap = {
  cart: cartIcon,
  heart: heartIcon,
  search: searchNewIcon,
  "search-old": searchIcon,
  lock: lockIcon,
  account: accountIcon,
  star: starIcon,
  phone: phoneIcon,
  mail: mailIcon,
  "map-pin": mapPinIcon,
  eye: eyeIcon,
  "quick-view": quickViewIcon,
  instagram: instagramIcon,
  facebook: facebookIcon,
  tiktok: tiktokIcon,
} as const;

export type GlossyIconName = keyof typeof iconMap;

interface GlossyIconProps {
  name: GlossyIconName;
  className?: string;
  size?: number;
}

const GlossyIcon = ({ name, className = "", size = 20 }: GlossyIconProps) => (
  <img
    src={iconMap[name]}
    alt=""
    width={size}
    height={size}
    className={`inline-block object-contain shrink-0 ${className}`}
    draggable={false}
  />
);

export default GlossyIcon;
